import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  createFetchingItemsSlice,
  type FetchingItemsState,
} from "features/Application/slices/createFetchingItemsSlice";
import { fetchManagedByDepartments } from "../../thunks/addUserThunk";

export const initialState: FetchingItemsState<string> = {
  isLoading: false,
  items: [],
  itemsCount: 0,
};

const managedByDepartmentsSlice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.EditAccount,
    name: "ManagedByDepartments",
    namespace: ReducerNamespaceTypes.Accounts,
  },
  thunk: fetchManagedByDepartments,
  reducers: {},
});

export default managedByDepartmentsSlice.reducer;
